import React, { useContext, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import tfbank21_logo_white from 'img/tf-logos/tfbank21-logo-white.svg'
import tfbank21_logo_symbol_white from 'img/tf-logos/tfbank21-logo-symbol-white.svg'
import { AuthContext } from 'exports'
import { menuItems } from '../../constants/menuItems/menuItems'
import { ILinks } from 'constants/countryValueTypes'
import MyPagesContext from 'contexts/MyPagesContext'
import './Footer.scss'

export default function Footer() {
	const { t, i18n } = useTranslation()
	const [isApplicationPage, setIsApplicationPage] = useState<boolean>(false)
	const { isAuthenticated } = useContext(AuthContext)
	const { staticCountryValues, productType } = useContext(MyPagesContext)

	const urlSearch = window.location.search.toLowerCase()
	const urlPath = window.location.pathname.toLowerCase()
	const [links, setLinks] = useState<ILinks>()

	useEffect(
		() => {
			if (
				urlSearch.includes('application') ||
				urlPath.includes('application')
			) {
				setIsApplicationPage(true)
			} else {
				setIsApplicationPage(false)
			}
		},
		[], //eslint-disable-line
	)

	useEffect(() => {
		if (staticCountryValues) {
			setLinks(staticCountryValues.links())
		}
	}, [staticCountryValues, i18n.language])

	return (
		<div id="footer">
			{isAuthenticated && staticCountryValues !== undefined && (
				<div
					className={
						isApplicationPage
							? 'footer-logged-in application-page'
							: 'footer-logged-in'
					}>
					<div className="footer-container container">
						<div className="footer-header-icon">
							<img src={tfbank21_logo_white} alt="TF Bank AB" />
						</div>
						<div className="footer-content">
							<div className="footer-address-information">
								{Object.entries(
									staticCountryValues.address,
								).map(([key, value]) => {
									return (
										<span className={key} key={key}>
											{t(value)}
										</span>
									)
								})}
							</div>
							{!isApplicationPage ? (
								<div className="pt-2 footer-general-information">
									<span>{t('GeneralInformation')}</span>
									{menuItems.map((link, i) => (
										<span key={i}>
											<Link to={link.route}>
												{t(link.text)}
											</Link>
										</span>
									))}
								</div>
							) : null}
							<div className="pt-2 footer-about-us">
								<span>TF Bank</span>
								{links?.about !== undefined && (
									<span>
										<a
											target="_blank"
											href={links.about.link}
											rel="noopener noreferrer">
											{t('AboutUs')}
										</a>
									</span>
								)}
								{links?.forms !== undefined && (
									<span>
										<a
											target="_blank"
											href={links?.forms.link}
											rel="noopener noreferrer">
											{t('Forms')}
										</a>
									</span>
								)}
								{links?.financialDifficulties !== undefined && (
									<span>
										<a
											target="_blank"
											href={
												links.financialDifficulties.link
											}
											rel="noopener noreferrer">
											{t('FinancialDifficulties')}
										</a>
									</span>
								)}
								{links?.consumerLoan !== undefined && (
									<span>
										<a
											target="_blank"
											href={links.consumerLoan.link}
											rel="noopener noreferrer">
											{t('ConsumerLoan')}
										</a>
									</span>
								)}
								{links?.cashLoan !== undefined && (
									<span>
										<a
											target="_blank"
											href={links.cashLoan.link}
											rel="noopener noreferrer">
											{t('Cash')}
										</a>
									</span>
								)}
								{links?.carLoan !== undefined && (
									<span>
										<a
											target="_blank"
											href={links.carLoan.link}
											rel="noopener noreferrer">
											{t('CarLoan')}
										</a>
									</span>
								)}
								{links?.renovationLoan !== undefined && (
									<span>
										<a
											target="_blank"
											href={links.renovationLoan.link}
											rel="noopener noreferrer">
											{t('RenovationLoan')}
										</a>
									</span>
								)}
								{links?.refinance !== undefined && (
									<span>
										<a
											target="_blank"
											href={links.refinance.link}
											rel="noopener noreferrer">
											{t('Refinance')}
										</a>
									</span>
								)}
							</div>
							{staticCountryValues.productSpecific.map(
								(value, key) => {
									if (value.productType === productType) {
										return (
											<div
												key={
													'footer-customer-support' +
													key
												}
												className="pt-2 footer-customer-support">
												<span>
													{t('CustomerSupport')}
												</span>
												{staticCountryValues.country ===
												'fi' ? (
													<>
														<span className="footer-span-block">
															<FontAwesomeIcon
																icon="phone-alt"
																className="mr-1"
															/>
															{value
																.contactInformation
																.phoneNumber +
																' ' +
																`(${t(
																	'RegularDepositAccount',
																)})`}
														</span>
														<span className="footer-span-block">
															<FontAwesomeIcon
																icon="phone-alt"
																className="mr-1"
															/>
															{value
																.contactInformation
																.phoneNumber2 +
																' ' +
																`(${t(
																	'RegularLoan',
																)})`}
														</span>
													</>
												) : (
													<span className="footer-span-block">
														<FontAwesomeIcon
															icon="phone-alt"
															className="mr-1"
														/>
														{
															value
																.contactInformation
																.phoneNumber
														}
													</span>
												)}
												<span className="footer-span-block">
													<FontAwesomeIcon
														icon="envelope"
														className="mr-1"
													/>{' '}
													{
														value.contactInformation
															.email
													}
												</span>
												{staticCountryValues.country ===
												'lv' ? (
													<div className="pt-2 department-delayed-payments">
															<span>
																{t(
																	'DepartmentOfDelayedPayments',
																)}
															</span>
															<span className="footer-span-block">
																<FontAwesomeIcon
																	icon="phone-alt"
																	className="mr-1"
																/>
																{
																	value
																		.contactInformation
																		.phoneNumber2
																}
															</span>
															<span className="footer-span-block">
																<FontAwesomeIcon
																	icon="envelope"
																	className="mr-1"
																/>{' '}
																{
																	value
																		.contactInformation
																		.email2
																}
															</span>
														</div>
												) : (
													<></>
												)}
											</div>
										)
									} else return null
								},
							)}
						</div>
						<div className="border-footer mt-4">
							<div>
								<p
									id="footer-copyright"
									className="pt-4 pb-2 d-flex flex-row-reverse">
									© {new Date().getFullYear()}{' '}
									{staticCountryValues.copyRight}
								</p>
							</div>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export function FooterLoggedOut() {
	const { staticCountryValues, productType } = useContext(MyPagesContext)
	const { t } = useTranslation()

	return (
		<div id="footer">
			<div className="footer-logged-out">
				<Row>
					<Col>
						<div id="footer-copyright">
							<img
								src={tfbank21_logo_symbol_white}
								alt="TF Bank AB"
							/>
							{`© ${new Date().getFullYear()} ${
								staticCountryValues === undefined
									? 'TF Bank AB'
									: staticCountryValues?.copyRight
							}`}
						</div>
						<div id="footer-contact">
							{staticCountryValues?.productSpecific.map(
								(value, key) => {
									if (value.productType === productType) {
										return (
											<div key={key}>
												{staticCountryValues.country ===
												'fi' ? (
													<div className="footer-contact-phone-number">
														<a
															href={`tel:${value.contactInformation.phoneNumber}`}>
															{value
																.contactInformation
																.phoneNumber +
																`, (${t(
																	'RegularDepositAccount',
																)}),`}
														</a>
														<a
															href={`tel:${value.contactInformation.phoneNumber2}`}>
															{value
																.contactInformation
																.phoneNumber2 +
																`, (${t(
																	'RegularLoan',
																)}),`}
														</a>
													</div>
												) : (
													<div className="footer-contact-phone-number">
														<a
															href={`tel:${value.contactInformation.phoneNumber}`}>
															{
																value
																	.contactInformation
																	.phoneNumber
															}
														</a>
														{','}
													</div>
												)}
												{staticCountryValues.country ===
												'lv' ? (
													<div className="footer-contact-phone-number">
														<a
															href={`tel:${value.contactInformation.phoneNumber2}`}>
															{
																value
																	.contactInformation
																	.phoneNumber2
															}
														</a>
														{','}
													</div>
												) : (
													<></>
												)}
											</div>
										)
									} else return null
								},
							)}
							{staticCountryValues !== undefined &&
								Object.entries(
									staticCountryValues?.address,
								).map(([key, value]) => {
									switch (key) {
										case 'zipCodeAndCity':
											return value
										case 'postalAddress':
											return ''
										default:
											return value + ', '
									}
								})}
						</div>
					</Col>
				</Row>
			</div>
		</div>
	)
}
